// Translation: Verification > Landing > Form (English)
export default Object.freeze({
	form: {
		actions: {
			verifyAccount: 'Verify account'
		},
		fields: {
			code: {
				placeholder: 'Enter verification code'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'Resend code',
					success: 'Code resent!'
				}
			}
		},
		title: 'Account verification'
	}
})
